import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/landing_what_make_us_better.png")